import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { Spinner } from "../compose/states";

/**
 * The authentication wall (ia-and-flows §1 / §9 rule 1): the SPA shell serves
 * NO data unauthenticated. Every route except /login and /set-password is
 * wrapped here. Deny-by-default — while the session hydrates we hold, and a
 * 401 sends the visitor to /login (preserving the intended destination).
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
        <Spinner label="Restoring your session…" />
      </div>
    );
  }
  if (status === "anon") {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
